// src/i18n/errors.ts —— 06 admin-console 全局约定「通用错误码 → 文案」（键名对齐 shared/src/errors.ts ADMIN_ERRORS）；1501 → toastNoPerm 在外壳文案包
export const I18N_ADMIN_ERRORS = {
  zh: {
    err1001: '账号或密码错误',
    err1002: '尝试过于频繁，请 {n} 秒后再试',
    err1004: '请输入动态验证码',
    err1005: '该邮箱已被其他账号使用',
    err1006: '动态验证码错误',
    err1008: '该 Telegram ID 已属于其他账号，需人工合并',
    err1105: '该用户存在交易手续费欠费，需先入账抵扣',
    err1205: '当前卡状态不允许该操作',
    errCardPendingAuth: '卡上有未完结的授权交易（{n} 笔），暂不能销卡。请等待交易结算或撤销后再试。', // 1205 reason=pending_authorization（{n} ← pending_count）
    err1207: '金额超出可调整范围',
    err1208: '该卡产品不支持此操作',
    err1209: '超出单卡额度上限',
    err1211: '单据当前状态不允许该操作',
    err1212: '该卡有处理中的操作 {inflight_biz_no}，请稍后再试',
    err1301: '下级费率不能高于上级',
    err1301Below: '上级费率不能低于其直接下级',
    err1303: '费率超出平台上限',
    err1304: '该代理存在佣金余额、未结算佣金或在途提佣，不可删除',
    err1305: '已达最大层级，不可再设下级',
    errSubtreeTooLarge: '下级过多（>5000），请联系技术处理', // 1012 reason=subtree_too_large（删除代理子树超限，用户 2026-10-18 D3）
    err1306: '登录账号已存在',
    errPriceBelowParent: '售价不能低于上级售价 {parent_eff}', // 1310（0045，C-09 代改售价）
    err1401: '上游拒绝：{message}',
    err1403: '上游暂不可用，请稍后重试',
    err1503: '该功能已关闭或系统维护中',
    errExportLimit: '导出行数超过 5000，请缩小筛选范围后重试',
    toastNetwork: '网络异常，请稍后重试', // 本计划定稿（TD-839 后台网络错误键，06 未给文案）
  },
  en: {
    err1001: 'Incorrect account or password',
    err1002: 'Too many attempts. Retry in {n}s',
    err1004: 'Enter your one-time code',
    err1005: 'Email already in use',
    err1006: 'Incorrect one-time code',
    err1008: 'Telegram ID belongs to another account; manual merge required',
    err1105: 'User has unpaid fees',
    err1205: 'Card status does not allow this',
    errCardPendingAuth: 'This card has {n} pending authorization(s) and cannot be closed yet. Please try again after they settle or are reversed.',
    err1207: 'Amount exceeds the adjustable range',
    err1208: 'Not supported by this card product',
    err1209: 'Exceeds the per-card limit',
    err1211: 'This operation is not allowed in the current state',
    err1212: 'Another operation {inflight_biz_no} is in progress for this card',
    err1301: "A sub-agent's rate cannot exceed its parent's",
    err1301Below: "A parent's rate cannot go below its direct sub-agents'",
    err1303: 'Rate exceeds the platform cap',
    err1304: 'Agent has balance, unsettled or in-flight withdrawals',
    err1305: 'Max level reached; this agent cannot have sub-agents',
    errSubtreeTooLarge: 'Too many sub-agents (>5000); please contact the technical team',
    err1306: 'Login account already exists',
    errPriceBelowParent: "Price cannot be lower than the upline's price {parent_eff}",
    err1401: 'Upstream rejected: {message}', // 本计划定稿（06 只给 zh）
    err1403: 'Upstream unavailable, please retry later', // 本计划定稿（06 只给 zh）
    err1503: 'Feature disabled or under maintenance',
    errExportLimit: 'Export exceeds 5,000 rows. Narrow the filters and retry.',
    toastNetwork: 'Network error. Please retry', // 本计划定稿
  },
} as const;
